import { render } from "./TransactionsBody.vue?vue&type=template&id=9fdefd28&scoped=true"
import script from "./TransactionsBody.vue?vue&type=script&lang=js"
export * from "./TransactionsBody.vue?vue&type=script&lang=js"

import "./TransactionsBody.vue?vue&type=style&index=0&id=9fdefd28&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fdefd28"]])

export default __exports__